/* =====================================================================
   hoh-wallet.js · R594 · THE ONE DOOR THE MONEY GOES THROUGH
   FramedFantasy · Hall of Heroes

   ⛔ WHY THIS FILE EXISTS.
   Hearts used to live only in localStorage['hoh-heart-bank-v1'], written
   from 23 places across four files. A phone and a laptop held two separate
   piles, and either could be edited by hand. R589 moved the authority to
   Supabase. This is the client half: one funnel, so the server can be told
   about a move without rewriting 63 call sites.

   ⛔ THE MIRROR IS NOT REMOVED, AND THAT IS THE WHOLE TRICK.
   bankGet(), getHeartBank() and heartsRemainingToday() are read
   SYNCHRONOUSLY inside expressions all over the game (`canAfford(n)`,
   `bank >= cost`, a label mid-render). Making them async would mean touching
   every one of those sites. So localStorage stays, demoted from the truth to
   a CACHE of the server's number. Reads stay instant and unchanged. Only
   WRITES learn to talk to the server, and they do it through here.

   ⛔ OPTIMISTIC, WITH A REAL ROLLBACK. Jan's ruling: four fifths of traffic is
   a phone, and a spinner on every purchase would be a cost paid by everyone
   on every tap forever. So the mirror moves immediately and the server
   confirms behind it. If the server refuses, the mirror is put back and the
   caller is told. A refused spend is rare; a slow game is permanent.

   ⛔ EVERY CALL CARRIES A REQUEST ID. The server's ledger is keyed on
   (account, request id), so a retry, a double tap or two tabs racing the same
   action settle as ONE move. Without it a flaky connection charges twice.
   ===================================================================== */
(function () {
  'use strict';
  if (window.HOHWallet) return;

  var HEART_KEY   = 'hoh-heart-bank-v1';   /* unchanged: 63 readers depend on it */
  var CRYSTAL_KEY = 'hoh-crystal-bank-v1';
  var META_KEY    = 'hoh-wallet-meta-v1';
  var BUY_PENDING_PREFIX = 'hoh-crystal-buy-pending-v1:';
  var HEART_APPLY_PENDING_PREFIX = 'hoh-heart-apply-pending-v1:';
  var RECONCILE_PENDING_PREFIX = 'hoh-wallet-reconcile-pending-v1:';
  var WALLET_OWNER_KEY = 'hoh-wallet-owner-v1';
  var WALLET_CARRY_PREFIX = 'hoh-wallet-carry-v1:';
  /* ⛔ R601 · THE SHADOW: the last balance the SERVER told us.
     23 places in this theme still write hoh-heart-bank-v1 directly (Explore
     the Hall alone has 15). Those never reach the server, so a sync that
     simply overwrote the mirror with the server's number DESTROYED every
     heart earned through them. That is a live economy losing money, and it is
     why hearts kept resetting to 0.
     The shadow is what makes the difference visible: mirror minus shadow is
     exactly what was earned or spent behind the funnel's back, and the sync
     pushes that up instead of throwing it away. It fixes all 23 at once, and
     any added later, which chasing each site individually would not. */
  var SHADOW_KEY  = 'hoh-wallet-shadow-v1';
  var HEART_MAX   = 9999;                  /* mirrors ff_wallet_config.heart_max */

  /* ---------- storage, defensively ---------- */
  function readInt(k) {
    try { var v = parseInt(localStorage.getItem(k) || '0', 10); return (v === v) ? Math.max(0, v) : 0; }
    catch (_) { return 0; }
  }
  function writeInt(k, v) {
    try { localStorage.setItem(k, String(Math.max(0, v | 0))); return true; } catch (_) { return false; }
  }
  function readMeta() {
    try { return JSON.parse(localStorage.getItem(META_KEY) || '{}') || {}; } catch (_) { return {}; }
  }
  function writeMeta(m) { try { localStorage.setItem(META_KEY, JSON.stringify(m || {})); } catch (_) {} }
  /* ⛔ NO Object.assign. Every other file here is written ES5-style for the
     same reason: this ships to whatever browser a player brings, and one
     unsupported builtin takes the whole wallet down inside a render path. */
  function markStale() { var m = readMeta(); m.stale = true; writeMeta(m); }

  /* ---------- account, the same way every other module reads it ---------- */
  function email() {
    try { return String((typeof window.hohYourHallEmail === 'function' ? window.hohYourHallEmail() : '') || '').trim().toLowerCase(); }
    catch (_) { return ''; }
  }
  function pin() {
    try { var t = JSON.parse(localStorage.getItem('hoh-your-hall-token') || 'null'); return (t && t.pin) || ''; }
    catch (_) { return ''; }
  }
  function signedIn() { return !!(email() && pin()); }
  /* ⛔ A scope is captured BEFORE a request and re-checked after it. A sign-out
     or account switch mid-flight must never let account A's reply land on
     account B's wallet, which is the exact bug the shop's own refund path was
     written to avoid. */
  function scope() { return { email: email(), pin: pin() }; }
  function stillCurrent(s) { return !!s && s.email === email() && s.pin === pin(); }
  function walletOwner(){try{return String(localStorage.getItem(WALLET_OWNER_KEY)||'').trim().toLowerCase();}catch(_){return '';}}
  function setWalletOwner(who){try{localStorage.setItem(WALLET_OWNER_KEY,String(who||'').trim().toLowerCase());}catch(_){}}
  function crystalBuyPendings(forEmail) {
    var who=String(forEmail || email() || '').trim().toLowerCase();
    if(!who)return [];
    try{
      var raw=JSON.parse(localStorage.getItem(BUY_PENDING_PREFIX+who)||'null');
      var rows=Object.prototype.toString.call(raw)==='[object Array]'?raw:(raw?[raw]:[]);
      var out=[],seen={};
      rows.forEach(function(row){
        var qty=Number(row&&row.qty),cost=Number(row&&row.cost),id=String(row&&row.id||'');
        if(!id||seen[id]||!isFinite(qty)||Math.floor(qty)!==qty||qty<1||qty>2147483647||
           !isFinite(cost)||Math.floor(cost)!==cost||cost<1)return;
        seen[id]=1;out.push({id:id,qty:qty,cost:cost,email:who});
      });
      return out;
    }catch(_){return [];}
  }
  function crystalBuyPending(forEmail) {
    var rows=crystalBuyPendings(forEmail);return rows.length?rows[0]:null;
  }
  function saveCrystalBuyPending(row) {
    if(!row||!row.email)return;
    try{
      var rows=crystalBuyPendings(row.email),found=false;
      rows.forEach(function(saved){if(saved.id===row.id)found=true;});
      if(!found)rows.push({id:row.id,qty:row.qty,cost:row.cost});
      localStorage.setItem(BUY_PENDING_PREFIX+row.email,JSON.stringify(rows));
    }catch(_){}
  }
  function clearCrystalBuyPending(row) {
    if(!row||!row.email)return;
    try{
      var rows=crystalBuyPendings(row.email).filter(function(saved){return saved.id!==row.id;});
      if(rows.length)localStorage.setItem(BUY_PENDING_PREFIX+row.email,JSON.stringify(rows));
      else localStorage.removeItem(BUY_PENDING_PREFIX+row.email);
    }catch(_){}
  }
  /* A signed-in Heart move is optimistic, so mirror-shadow includes it until
     the RPC answers. It is NOT raw R601 drift and must never be sent under a
     second reconcile id. Keep the exact logical request durably until its
     answer is definitive; this also survives a reload after a lost reply. */
  function heartApplyPendings(forEmail) {
    var who=String(forEmail || email() || '').trim().toLowerCase();
    if(!who)return [];
    try{
      var raw=JSON.parse(localStorage.getItem(HEART_APPLY_PENDING_PREFIX+who)||'[]');
      var rows=Object.prototype.toString.call(raw)==='[object Array]'?raw:[];
      var out=[],seen={};
      rows.forEach(function(row){
        var id=String(row&&row.id||''),delta=Number(row&&row.delta),localDelta=Number(row&&row.localDelta);
        var reason=String(row&&row.reason||''),coldBase=row&&row.coldBase;
        if(!id||seen[id]||!reason||!isFinite(delta)||Math.floor(delta)!==delta||
           !isFinite(localDelta)||Math.floor(localDelta)!==localDelta)return;
        if(coldBase!=null){coldBase=Number(coldBase);if(!isFinite(coldBase)||Math.floor(coldBase)!==coldBase||coldBase<0)coldBase=null;}
        seen[id]=1;out.push({email:who,id:id,delta:delta,localDelta:localDelta,reason:reason,
          echoPresent:row.echoPresent!==false,coldBase:coldBase});
      });
      return out;
    }catch(_){return [];}
  }
  function saveHeartApplyPending(row) {
    if(!row||!row.email)return;
    try{
      var rows=heartApplyPendings(row.email),found=false;
      rows.forEach(function(saved){if(saved.id===row.id)found=true;});
      if(!found)rows.push({id:row.id,delta:row.delta,localDelta:row.localDelta,reason:row.reason,
        echoPresent:row.echoPresent!==false,coldBase:row.coldBase==null?null:row.coldBase});
      localStorage.setItem(HEART_APPLY_PENDING_PREFIX+row.email,JSON.stringify(rows));
    }catch(_){}
  }
  function clearHeartApplyPending(row) {
    if(!row||!row.email)return;
    try{
      var rows=heartApplyPendings(row.email).filter(function(saved){return saved.id!==row.id;});
      if(rows.length)localStorage.setItem(HEART_APPLY_PENDING_PREFIX+row.email,JSON.stringify(rows));
      else localStorage.removeItem(HEART_APPLY_PENDING_PREFIX+row.email);
    }catch(_){}
  }
  function heartApplyLocalDelta(forEmail){
    return heartApplyPendings(forEmail).reduce(function(sum,row){return sum+(row.echoPresent?row.localDelta:0);},0);
  }
  function detachHeartApplyEchoes(forEmail){
    var who=String(forEmail||'').trim().toLowerCase();if(!who)return;
    try{
      var rows=heartApplyPendings(who).map(function(row){
        return {id:row.id,delta:row.delta,localDelta:row.localDelta,reason:row.reason,
          echoPresent:false,coldBase:row.coldBase};
      });
      if(rows.length)localStorage.setItem(HEART_APPLY_PENDING_PREFIX+who,JSON.stringify(rows));
    }catch(_){}
  }
  function walletReconcilePending(forEmail){
    var who=String(forEmail||email()||'').trim().toLowerCase();if(!who)return null;
    try{
      var row=JSON.parse(localStorage.getItem(RECONCILE_PENDING_PREFIX+who)||'null');
      var id=String(row&&row.id||''),delta=Number(row&&row.delta);
      if(!id||!isFinite(delta)||Math.floor(delta)!==delta||delta===0||Math.abs(delta)>HEART_MAX)return null;
      return {email:who,id:id,delta:delta};
    }catch(_){return null;}
  }
  function saveWalletReconcilePending(row){
    if(!row||!row.email)return;
    try{localStorage.setItem(RECONCILE_PENDING_PREFIX+row.email,
      JSON.stringify({id:row.id,delta:row.delta}));}catch(_){}
  }
  function clearWalletReconcilePending(row){
    if(!row||!row.email)return;
    try{
      var live=walletReconcilePending(row.email);
      if(live&&live.id===row.id)localStorage.removeItem(RECONCILE_PENDING_PREFIX+row.email);
    }catch(_){}
  }
  /* HEART_KEY/SHADOW_KEY are legacy global keys, while the login can change.
     Preserve only the old owner's genuine raw delta before relabelling that
     cache. Pending funnel echoes live in their exact-id journal and are
     deliberately excluded; otherwise returning to the account would count
     the same earn twice. */
  function walletCarry(forEmail){
    var who=String(forEmail||'').trim().toLowerCase();if(!who)return null;
    try{
      var row=JSON.parse(localStorage.getItem(WALLET_CARRY_PREFIX+who)||'null');
      if(!row)return null;
      var raw=row.raw,cold=row.cold;
      if(raw!=null){raw=Number(raw);if(!isFinite(raw)||Math.floor(raw)!==raw||Math.abs(raw)>HEART_MAX)raw=null;}
      if(cold!=null){cold=Number(cold);if(!isFinite(cold)||Math.floor(cold)!==cold||cold<0||cold>HEART_MAX)cold=null;}
      return raw==null&&cold==null?null:{raw:raw,cold:cold};
    }catch(_){return null;}
  }
  function walletCarrySnapshot(forEmail){
    var who=String(forEmail||'').trim().toLowerCase();if(!who)return;
    try{
      var pending=heartApplyLocalDelta(who),reconcile=walletReconcilePending(who);
      var reconciling=reconcile?reconcile.delta:0,hasShadow=localStorage.getItem(SHADOW_KEY)!==null,row;
      if(hasShadow)row={raw:Math.max(-HEART_MAX,Math.min(HEART_MAX,
        hearts()-readInt(SHADOW_KEY)-pending-reconciling))};
      else row={cold:Math.max(0,Math.min(HEART_MAX,hearts()-pending))};
      return row;
    }catch(_){return null;}
  }
  function saveWalletCarry(forEmail,row){
    var who=String(forEmail||'').trim().toLowerCase();if(!who||!row)return;
    try{localStorage.setItem(WALLET_CARRY_PREFIX+who,JSON.stringify(row));}catch(_){}
  }
  function captureWalletCarry(forEmail){
    saveWalletCarry(forEmail,walletCarrySnapshot(forEmail));
  }

  function sb() { try { return window.hohSupabaseClient || null; } catch (_) { return null; } }
  function rpc(name, params) {
    var c = sb();
    if (!c || typeof c.rpc !== 'function') return Promise.resolve({ error: { message: 'no client' } });
    return c.rpc(name, params).then(function (r) { return r; }, function (e) { return { error: e }; });
  }

  /* A request id that is stable for one user action and unique across them.
     Not random alone: a retry of the SAME action must reuse it, so callers
     pass one in when they are retrying. */
  var seq = 0;
  function reqId(tag) {
    seq++;
    return String(tag || 'w') + ':' + Date.now().toString(36) + ':' + seq + ':' +
      Math.floor(Math.random() * 1e6).toString(36);
  }

  /* ---------- telling the rest of the page ---------- */
  /* ⛔ hoh:hearts-bumped IS LOAD BEARING. section-core clears its cached bank
     on it, fresh-faces re-syncs, and the corner counter repaints. A wallet
     that moved a number without firing this would leave every counter on the
     page frozen, which is written down in bankAdd's own comment. */
  function announce(deltaHearts, reason) {
    try {
      document.dispatchEvent(new CustomEvent('hoh:hearts-bumped', {
        detail: (deltaHearts < 0 ? { spent: -deltaHearts } : { gained: deltaHearts })
      }));
    } catch (_) {}
    try { if (typeof window.hohRenderHeaderCounter === 'function') window.hohRenderHeaderCounter(); } catch (_) {}
    try { if (!window.__hohHeartHint && window.hohHeartHint) window.hohHeartHint(reason || ''); } catch (_) {}
  }
  function announceCrystals() {
    try { document.dispatchEvent(new CustomEvent('hoh:crystals-changed', {})); } catch (_) {}
    try { if (typeof window.hohRenderHeaderCounter === 'function') window.hohRenderHeaderCounter(); } catch (_) {}
  }
  function announcePacks() {
    try { document.dispatchEvent(new CustomEvent('hoh:packs-changed', {})); } catch (_) {}
    try { if (typeof window.hohRenderHeaderCounter === 'function') window.hohRenderHeaderCounter(); } catch (_) {}
  }

  /* ---------- the public reads, all synchronous ---------- */
  function hearts()   { return readInt(HEART_KEY); }
  function crystals() { return readInt(CRYSTAL_KEY); }
  function meta()     { return readMeta(); }
  function unlocked() { var m = readMeta(); return !!m.crystals_unlocked; }
  function packsOpened() { return readMeta().packs_opened | 0; }
  function packsUnopened() { return readMeta().packs_unopened | 0; }
  function accountPacksUnopened() { return readMeta().packs_unopened_account | 0; }
  function battlePacksUnopened() { return readMeta().packs_unopened_battle | 0; }
  function unlockPacks() { var m = readMeta(); return m.unlock_packs == null ? 10 : (m.unlock_packs | 0); }
  function crystalPrice(){ var m = readMeta(); return m.crystal_price == null ? 150 : (m.crystal_price | 0); }
  /* R605: `crystal_buy_max` is retained in the synced metadata only so an old
     tab can coexist with a new one during deployment. It is no longer an
     economy rule. The honest maximum is the number of WHOLE crystals this
     account's current Heart mirror can afford; the RPC rechecks the server
     balance atomically before moving either currency. A non-positive price is
     configuration trouble, not permission to expose an unbounded slider. */
  function crystalBuyMax(){
    var price = crystalPrice(), have = hearts();
    if (!isFinite(price) || Math.floor(price) !== price || price <= 0) return 0;
    return Math.max(0, Math.floor(have / price));
  }
  function crystalsSpent(){ return readMeta().crystals_spent | 0; }
  function dailyCrystalReady(){ return !!readMeta().daily_crystal_ready; }

  /* ---------- pulling server truth into the mirror ---------- */
  var syncFlights = {}, lastSyncAt = {}, serverRevision = 0;
  var heartApplyFlights = {}, heartRecoveryFlights = {}, walletAuthorityTails = {};
  function ownsWallet(s){return stillCurrent(s)&&walletOwner()===s.email;}
  function syncFlight(forEmail){return syncFlights[String(forEmail||'').trim().toLowerCase()]||null;}
  function withWalletAuthority(s,authorityHeld,work){
    if(authorityHeld)return Promise.resolve().then(work);
    try{
      if(navigator.locks&&typeof navigator.locks.request==='function'){
        return navigator.locks.request('hoh-wallet-authority:'+s.email,{mode:'exclusive'},function(){
          if(!stillCurrent(s))return false;
          return work();
        });
      }
    }catch(_){}
    /* Web Locks is not universal. Keep the same ordering guarantee inside one
       tab as a fallback; the durable journals still fail closed across old
       browsers/tabs rather than inventing a second logical request. */
    var prior=walletAuthorityTails[s.email]||Promise.resolve();
    var run=prior.then(function(){
      if(!stillCurrent(s))return false;
      return work();
    },function(){
      if(!stillCurrent(s))return false;
      return work();
    });
    walletAuthorityTails[s.email]=run.then(function(){},function(){});
    return run;
  }
  function removeHeartApplyEcho(row) {
    /* Keep raw writes that happened after the optimistic move: only remove
       the exact local echo this journal row introduced. The following sync
       will pull the idempotently settled/refused server truth and reconcile
       any genuinely raw remainder once. */
    if(!row||walletOwner()!==row.email||row.echoPresent===false)return 0;
    var live=null;
    heartApplyPendings(row.email).forEach(function(candidate){if(candidate.id===row.id)live=candidate;});
    if(!live||live.echoPresent===false)return 0;
    var now=hearts(),next=Math.max(0,Math.min(HEART_MAX,now-live.localDelta));
    writeInt(HEART_KEY,next);
    return next-now;
  }
  function settleHeartApplyPendings(s, recoveryJoined, authorityHeld) {
    if(!stillCurrent(s))return Promise.resolve(false);
    if(!recoveryJoined){
      if(heartRecoveryFlights[s.email])return heartRecoveryFlights[s.email];
      var recovery=settleHeartApplyPendings(s,true,authorityHeld).then(function(ok){
        if(heartRecoveryFlights[s.email]===recovery)delete heartRecoveryFlights[s.email];
        return ok;
      },function(){
        if(heartRecoveryFlights[s.email]===recovery)delete heartRecoveryFlights[s.email];
        return false;
      });
      heartRecoveryFlights[s.email]=recovery;
      return recovery;
    }
    var rows=heartApplyPendings(s.email);
    if(!rows.length)return Promise.resolve(true);
    var row=rows[0],flight=heartApplyFlights[row.email+'\n'+row.id];
    if(flight&&flight.then){
      /* The live apply may itself be queued behind the authority lock this
         recovery currently holds (boot/adopt can reach this path). Release
         instead of awaiting our own lock dependency; the queued apply keeps
         the exact journal and a later sync will settle it. */
      if(authorityHeld)return Promise.resolve(false);
      return flight.then(function(){return settleHeartApplyPendings(s,true,authorityHeld);},function(){return false;});
    }
    /* The first reply was lost. Replay the SAME ledger identity; never turn
       its optimistic mirror delta into a new earn_reconcile/spend_reconcile
       request. A second ambiguous reply leaves the blocker in place and the
       caller fails closed. */
    return withWalletAuthority(s,authorityHeld,function(){
      /* Another tab may have settled this row while we waited for the shared
         authority lock. Re-read it inside the lock so its optimistic echo is
         never removed twice. */
      var liveRows=heartApplyPendings(s.email),live=null;
      liveRows.forEach(function(candidate){if(candidate.id===row.id)live=candidate;});
      if(!live)return true;
      if(!ownsWallet(s))return false;
      return ensureColdHeartBaseline(s,live).then(function(ready){
        if(!ready||!ownsWallet(s))return false;
        var currentRows=heartApplyPendings(s.email);
        if(!currentRows.length||currentRows[0].id!==live.id)return false;
        return rpc('hoh_wallet_apply',{
        p_email:s.email,p_pin:s.pin,p_currency:'hearts',p_delta:live.delta,
        p_reason:live.reason,p_request_id:live.id,
        p_device:(navigator.userAgent||'').slice(0,120)
        });
      }).then(function(res){
        if(res===false||!ownsWallet(s))return false;
        var d=res&&res.data;
        if(!d||d.status==='in_flight')return false;
        if(d.ok===true){
          removeHeartApplyEcho(live);
          clearHeartApplyPending(live);
          return true;
        }
        if(d.status==='unknown_reason'||d.status==='reason_direction'){
          /* Those are confirmed non-moves caused by a missing policy row. Keep
             Jan's original optimistic value as intentional raw drift; R601 can
             now carry it under the registered reconcile reason exactly once. */
          if(live.echoPresent===false&&ownsWallet(s))
            writeInt(HEART_KEY,Math.max(0,Math.min(HEART_MAX,hearts()+live.localDelta)));
          clearHeartApplyPending(live);
          return true;
        }
        removeHeartApplyEcho(live);
        clearHeartApplyPending(live);
        return true;
      },function(){return false;});
    }).then(function(ok){return ok?settleHeartApplyPendings(s,true,authorityHeld):false;},function(){return false;});
  }
  /* R603's atomic receipt contains the exact post-transaction crystal
     balance. Adopt it immediately so the last crystal disables every reroll
     before the network read-back finishes. The revision fences any wallet
     request that started before the receipt and would otherwise restore the
     pre-spend balance when it arrived late. */
  function applyCrystalReceipt(balance, expectedEmail) {
    var n = Number(balance), expected = String(expectedEmail || '').trim().toLowerCase();
    var who=expected||email();
    if (!signedIn() || who !== email() || (walletOwner()&&walletOwner()!==who) ||
        (!walletOwner()&&readMeta().wallet_live) ||
        !isFinite(n) || Math.floor(n) !== n || n < 0) return false;
    if(!walletOwner())setWalletOwner(who);
    var before = crystals(), olderSync = syncFlight(who);
    serverRevision++;
    var receiptRevision = serverRevision;
    lastSyncAt[who] = 0;
    writeInt(CRYSTAL_KEY, n);
    if (before !== n) announceCrystals();
    /* A forced sync coalesces with an existing request. If that request began
       before this receipt, its response is fenced below; follow it with one
       genuinely post-commit read so spend counters and daily metadata catch
       up too, while the exact balance above stays immediately usable. */
    if (olderSync && olderSync.then) {
      var refresh = function () {
        if (serverRevision === receiptRevision && (!expected || expected === email())) sync(true);
      };
      olderSync.then(refresh, refresh);
    }
    return true;
  }
  /* A crystal purchase moves BOTH balances in one database transaction. Its
     reply is therefore newer truth for both mirrors. Apply it before the
     follow-up read, and use the same revision fence as an ability receipt so
     a wallet read started before the purchase cannot put the spent Hearts or
     pre-purchase crystal count back. */
  function applyPurchaseReceipt(d, expectedEmail) {
    var h = Number(d && d.hearts), c = Number(d && d.crystals);
    var expected = String(expectedEmail || '').trim().toLowerCase();
    var who=expected||email();
    if (!signedIn() || who !== email() || walletOwner()!==who ||
        !isFinite(h) || Math.floor(h) !== h || h < 0 || h > 2147483647 ||
        !isFinite(c) || Math.floor(c) !== c || c < 0 || c > 2147483647) return false;
    var beforeH = hearts(), beforeC = crystals(), olderSync = syncFlight(who);
    /* R601 raw writers may have earned/spent Hearts since the last server
       shadow. A receipt replaces the server BASE, not that unsynced delta.
       Preserve mirror-minus-shadow on top of the receipt and let the forced
       sync below reconcile it. Otherwise buying a crystal could erase an
       Explore reward that had not reached the server yet. */
    var pendingDrift = beforeH - readInt(SHADOW_KEY);
    var nextH = Math.max(0, Math.min(HEART_MAX, h + pendingDrift));
    serverRevision++;
    var receiptRevision = serverRevision;
    lastSyncAt[who] = 0;
    writeInt(HEART_KEY, nextH);
    writeInt(SHADOW_KEY, h);
    writeInt(CRYSTAL_KEY, c);
    if (beforeH !== nextH) announce(nextH - beforeH, 'spend_crystal_buy');
    if (beforeC !== c) announceCrystals();
    if (olderSync && olderSync.then) {
      var refresh = function () {
        if (serverRevision === receiptRevision && (!expected || expected === email())) sync(true);
      };
      olderSync.then(refresh, refresh);
    }
    return true;
  }
  function validPurchaseSuccess(d,requested,expectedCost){
    var q=Number(d&&d.qty),cost=Number(d&&d.cost),h=Number(d&&d.hearts),c=Number(d&&d.crystals);
    return !!(d&&d.ok===true&&d.purchase_model==='r605-affordable-v1'&&
      (d.status==='ok'||d.status==='already')&&
      isFinite(q)&&Math.floor(q)===q&&q===requested&&
      isFinite(cost)&&Math.floor(cost)===cost&&cost===expectedCost&&cost>0&&
      isFinite(h)&&Math.floor(h)===h&&h>=0&&h<=HEART_MAX&&
      isFinite(c)&&Math.floor(c)===c&&c>=0&&c<=2147483647);
  }
  function applyServerState(d, ownerEmail) {
    if (!d || d.ok !== true) return false;
    var priorMeta = readMeta();
    var beforePacks = priorMeta.packs_unopened | 0;
    var unopened = d.packs_unopened == null ? beforePacks : (d.packs_unopened | 0);
    var accountUnopened = d.packs_unopened_account == null
      ? (priorMeta.packs_unopened_account | 0) : (d.packs_unopened_account | 0);
    var battleUnopened = d.packs_unopened_battle == null
      ? (priorMeta.packs_unopened_battle | 0) : (d.packs_unopened_battle | 0);
    writeInt(HEART_KEY, d.hearts | 0);
    /* the mirror and the shadow agree the moment the server speaks */
    writeInt(SHADOW_KEY, d.hearts | 0);
    writeInt(CRYSTAL_KEY, d.crystals | 0);
    writeMeta({
      packs_opened:        d.packs_opened | 0,
      packs_unopened:      Math.max(0, unopened),
      packs_unopened_account: Math.max(0, accountUnopened),
      packs_unopened_battle:  Math.max(0, battleUnopened),
      crystals_unlocked:   !!d.crystals_unlocked,
      unlock_packs:        d.unlock_packs | 0,
      crystal_price:       d.crystal_price | 0,
      crystal_buy_max:     d.crystal_buy_max | 0,
      crystals_spent:      d.crystals_spent | 0,
      daily_crystal_ready: !!d.daily_crystal_ready,
      wallet_live:         !!d.wallet_live,
      heart_max:           d.heart_max | 0,
      at:                  Date.now()
    });
    setWalletOwner(ownerEmail||email());
    if (beforePacks !== Math.max(0, unopened)) announcePacks();
    return true;
  }

  function validWalletState(d){
    var h=Number(d&&d.hearts),c=Number(d&&d.crystals),p=d&&d.packs_unopened;
    return !!(d&&d.ok===true&&isFinite(h)&&Math.floor(h)===h&&h>=0&&h<=HEART_MAX&&
      isFinite(c)&&Math.floor(c)===c&&c>=0&&c<=2147483647&&
      (p==null||(isFinite(Number(p))&&Math.floor(Number(p))===Number(p)&&Number(p)>=0&&Number(p)<=1000000)));
  }
  function ensureWalletOwner(s){
    if(!stillCurrent(s))return Promise.resolve(false);
    var owner=walletOwner();
    if(!owner){
      /* Before the owner marker existed, a server-backed global cache could
         belong to whichever account used this browser last. Do not blindly
         label it as the current login. Existing live wallets establish from
         that account's authoritative row without reconciling the anonymous
         mirror. A genuinely pre-server wallet still follows the one-time cold
         adoption path so its legacy Hearts are not discarded. */
      if(!readMeta().wallet_live){setWalletOwner(s.email);return Promise.resolve(true);}
      var anonymousBoundary=hearts();
      return rpc('hoh_wallet_get',{p_email:s.email,p_pin:s.pin}).then(function(res){
        if(!stillCurrent(s)||walletOwner())return false;
        var d=res&&res.data;if(!validWalletState(d))return false;
        var beforeH=hearts(),beforeC=crystals();
        var lateCurrent=Math.max(-HEART_MAX,Math.min(HEART_MAX,hearts()-anonymousBoundary));
        serverRevision++;
        if(!applyServerState(d,s.email))return false;
        if(lateCurrent){
          writeInt(HEART_KEY,Math.max(0,Math.min(HEART_MAX,Number(d.hearts)+lateCurrent)));
          writeInt(SHADOW_KEY,Number(d.hearts));
        }
        lastSyncAt[s.email]=Date.now();
        if(hearts()!==beforeH)announce(hearts()-beforeH,'account_sync');
        if(crystals()!==beforeC)announceCrystals();
        return true;
      },function(){return false;});
    }
    if(owner===s.email)return Promise.resolve(true);
    /* Never compute B's drift from A's global mirror/shadow. Fetch B while
       holding B's one wallet-authority lock, then atomically relabel the
       cache. A's exact-id journal stays account-scoped, but its local echo is
       marked detached before A's mirror is replaced. */
    var carry=walletCarry(s.email),boundaryMirror=hearts();
    var outgoingCarry=walletCarrySnapshot(owner);
    return rpc('hoh_wallet_get',{p_email:s.email,p_pin:s.pin}).then(function(res){
      if(!stillCurrent(s)||walletOwner()!==owner)return false;
      var d=res&&res.data;if(!validWalletState(d))return false;
      /* A prior visit to this account may predate its first shadow. That cold
         baseline belongs to this account (unlike the currently visible A
         mirror), so establish it by high-water adoption before restoring it. */
      if(carry&&carry.cold!=null){
        return rpc('hoh_wallet_adopt',{
          p_email:s.email,p_pin:s.pin,p_claim:carry.cold,
          p_device:(navigator.userAgent||'').slice(0,120)
        }).then(function(adoptRes){
          if(!stillCurrent(s)||walletOwner()!==owner||
             !(adoptRes&&adoptRes.data&&adoptRes.data.ok===true))return false;
          return rpc('hoh_wallet_get',{p_email:s.email,p_pin:s.pin});
        });
      }
      return res;
    }).then(function(res){
      if(res===false||!stillCurrent(s)||walletOwner()!==owner)return false;
      var d=res&&res.data;if(!validWalletState(d))return false;
      var beforeH=hearts(),beforeC=crystals();
      /* The outgoing owner was frozen before B's read. Movement after that
         snapshot was produced by the incoming B journey and must stay above
         B's server base, not be filed backward into A's carry. */
      var lateIncoming=Math.max(-HEART_MAX,Math.min(HEART_MAX,hearts()-boundaryMirror));
      saveWalletCarry(owner,outgoingCarry);
      detachHeartApplyEchoes(owner);
      serverRevision++;
      if(!applyServerState(d,s.email))return false;
      var incomingRaw=(carry&&carry.raw?carry.raw:0)+lateIncoming;
      if(incomingRaw){
        writeInt(HEART_KEY,Math.max(0,Math.min(HEART_MAX,Number(d.hearts)+incomingRaw)));
        writeInt(SHADOW_KEY,Number(d.hearts));
      }
      lastSyncAt[s.email]=Date.now();
      if(hearts()!==beforeH)announce(hearts()-beforeH,'account_sync');
      if(crystals()!==beforeC)announceCrystals();
      return true;
    },function(){return false;});
  }
  function ensureColdHeartBaseline(s,row){
    var hasShadow=false;
    try{hasShadow=localStorage.getItem(SHADOW_KEY)!==null;}catch(_){}
    if(hasShadow||!row||row.coldBase==null)return Promise.resolve(true);
    /* The legacy mirror predates any server shadow. Establish it with the
       wallet's existing high-water adoption BEFORE the queued Heart RPC. The
       optimistic delta remains visible; after the authoritative read it is
       layered back over the new baseline with any later queued echoes. */
    return rpc('hoh_wallet_adopt',{
      p_email:s.email,p_pin:s.pin,p_claim:row.coldBase,
      p_device:(navigator.userAgent||'').slice(0,120)
    }).then(function(adoptRes){
      if(!ownsWallet(s)||!(adoptRes&&adoptRes.data&&adoptRes.data.ok===true))return false;
      return rpc('hoh_wallet_get',{p_email:s.email,p_pin:s.pin});
    }).then(function(res){
      if(res===false||!ownsWallet(s))return false;
      var d=res&&res.data;if(!validWalletState(d))return false;
      var current=hearts(),pending=heartApplyLocalDelta(s.email);
      var rawAfter=current-row.coldBase-pending;
      serverRevision++;
      if(!applyServerState(d,s.email))return false;
      lastSyncAt[s.email]=Date.now();
      writeInt(HEART_KEY,Math.max(0,Math.min(HEART_MAX,Number(d.hearts)+pending+rawAfter)));
      try{localStorage.setItem('hoh-wallet-adopted-'+s.email,'1');}catch(_){}
      return true;
    },function(){return false;});
  }

  function sync(force, heartPendingsSettled, authorityHeld) {
    if (!signedIn()) return Promise.resolve(false);
    var s=scope();
    if(!authorityHeld){
      /* Coalesce only within the captured account. Account B must never join
         account A's in-flight read and mistake A's cache for an initialized B
         wallet. The authority lock is requested before any journal/drift
         decision and remains held through a possible reconcile RPC. */
      var joined=syncFlight(s.email);
      if(joined)return joined;
      var requested=withWalletAuthority(s,false,function(){
        if(!stillCurrent(s))return false;
        return sync(force,heartPendingsSettled,true);
      });
      var tracked=requested.then(function(ok){
        if(syncFlights[s.email]===tracked)delete syncFlights[s.email];
        return ok;
      },function(){
        if(syncFlights[s.email]===tracked)delete syncFlights[s.email];
        return false;
      });
      syncFlights[s.email]=tracked;
      return tracked;
    }
    if(!stillCurrent(s))return Promise.resolve(false);
    return ensureWalletOwner(s).then(function(ownerReady){
      if(!ownerReady||!ownsWallet(s))return false;
      if(!heartPendingsSettled&&heartApplyPendings(s.email).length){
        return settleHeartApplyPendings(s,true,true).then(function(ok){
          if(!ok||!ownsWallet(s))return false;
          return sync(force,true,true);
        });
      }
      var replayReconcile=walletReconcilePending(s.email);
      if(replayReconcile){
        /* The raw-drift RPC may have committed before its reply or before an
           account switch. Replay its exact ledger identity before reading a
           new base; never mint a second reconcile request for the same delta. */
        return rpc('hoh_wallet_apply',{
          p_email:s.email,p_pin:s.pin,p_currency:'hearts',p_delta:replayReconcile.delta,
          p_reason:replayReconcile.delta>0?'earn_reconcile':'spend_reconcile',
          p_request_id:replayReconcile.id,p_device:(navigator.userAgent||'').slice(0,120)
        }).then(function(replayRes){
          if(!ownsWallet(s))return false;
          var replayData=replayRes&&replayRes.data;
          if(!replayData||replayData.ok!==true)return false;
          clearWalletReconcilePending(replayReconcile);
          return sync(force,heartPendingsSettled,true);
        },function(){return false;});
      }
      if (!force && Date.now() - (lastSyncAt[s.email]||0) < 4000) return true;
      var startedRevision=serverRevision;
      return rpc('hoh_wallet_get', { p_email: s.email, p_pin: s.pin }).then(function (res) {
        if (!ownsWallet(s)) return false;
        if (startedRevision !== serverRevision) return false;
        var d = res && res.data;
        if (!validWalletState(d)) return false;
        /* An optimistic Heart apply can start after this wallet_get. Its
           mirror delta did not exist in the server snapshot above, and must
           not be classified as raw drift by this older read. Abort; the
           tracked apply (or exact-id recovery) will release a fresh sync. */
        if(heartApplyPendings(s.email).length)return false;
        /* ⛔ R601 · RECONCILE, NEVER CLOBBER.
           Everything the funnel does not see still lands in the mirror, so
           mirror minus shadow is exactly what was earned or spent behind its
           back. Push that to the server FIRST, then take the answer. Writing
           the server's number straight over the mirror is what was deleting
           hearts earned in Explore the Hall.
           ⛔ IT MUST WORK IN BOTH DIRECTIONS. Reconciling only upward would
           resurrect hearts a player spent on another device, because that
           device's mirror is legitimately lower than the server. Sending the
           real delta, whatever its sign, is the only version that is correct
           for one device and for two. */
        var mirror = hearts(), shadow = readInt(SHADOW_KEY);
        var hadShadow = false;
        try { hadShadow = localStorage.getItem(SHADOW_KEY) !== null; } catch (_) {}
        /* ⛔ THE FIRST SYNC HAS NO SHADOW, AND THAT IS EXACTLY WHEN A PLAYER
           NEEDS RESCUING. Skipping the reconcile there would let the server's
           number overwrite the browser ONE more time, which is precisely the
           reset Jan kept seeing.
           With no shadow the baseline is the LOWER of the two. If the browser
           is ahead, that gap is un-synced earnings and goes up. If the server
           is ahead, there is nothing to rescue and the server simply wins.
           It cannot double-count: adopt() runs before the first sync and has
           already raised the server to the browser's number, so the gap is
           zero by the time this looks. */
        var baseline = hadShadow ? shadow : Math.min(mirror, d.hearts | 0);
        var drift = mirror - baseline;
        if (drift !== 0 && Math.abs(drift) <= HEART_MAX) {
          var rid = 'reconcile:' + s.email + ':' + Date.now().toString(36) + ':' + drift;
          var reconcileRow={email:s.email,id:rid,delta:drift};
          saveWalletReconcilePending(reconcileRow);
          return rpc('hoh_wallet_apply', {
            p_email: s.email, p_pin: s.pin, p_currency: 'hearts',
            p_delta: drift, p_reason: drift > 0 ? 'earn_reconcile' : 'spend_reconcile',
            p_request_id: rid, p_device: (navigator.userAgent || '').slice(0, 120)
          }).then(function (r2) {
            if (!ownsWallet(s)) return false;
            var d2 = r2 && r2.data;
            /* the reconcile answered, so its balance is the truth. If it did
               not, keep the mirror as it is and try again next sync rather
               than taking a number that predates the drift. */
            if (d2 && d2.ok === true) {
              d.hearts = d2.balance | 0;
            } else {
              try { console.warn('R601 wallet reconcile refused: ' + ((d2 && d2.status) || 'no reply') +
                ' · drift ' + drift); } catch (_) {}
              return false;
            }
            return settle(d,mirror,reconcileRow);
          }, function () { return false; });
        }
        return settle(d);

        function settle(dd,reconcileMirror,committedReconcile) {
        if (startedRevision !== serverRevision) return false;
        if (!ownsWallet(s)) return false;
        if (heartApplyPendings(s.email).length && !committedReconcile) return false;
        /* A legacy writer can move the mirror while the reconcile RPC is in
           flight. The returned balance includes the original drift only; keep
           the later raw delta above the new server shadow for the next exact
           reconciliation instead of erasing it. */
        var beforeSettle=hearts(),pendingAtSettle=heartApplyLocalDelta(s.email);
        var lateRaw=reconcileMirror==null?0:beforeSettle-reconcileMirror-pendingAtSettle;
        var before = hearts(), beforeC = crystals();
        if(committedReconcile)clearWalletReconcilePending(committedReconcile);
        applyServerState(dd,s.email);
        /* A same-account apply publishes its optimistic echo before waiting
           for this lock. If that journal appeared in the tiny gap after the
           last check, layer the exact echo back over the server base instead
           of letting this sync erase it. Its RPC remains queued behind us. */
        var latePending=heartApplyLocalDelta(s.email);
        if(latePending||lateRaw)writeInt(HEART_KEY,Math.max(0,Math.min(HEART_MAX,
          Number(dd.hearts)+latePending+lateRaw)));
        captureWalletCarry(s.email);
        lastSyncAt[s.email]=Date.now();
        if (hearts() !== before) announce(hearts() - before, 'sync');
        if (crystals() !== beforeC) announceCrystals();
        /* ⛔ R598 · ALWAYS ANNOUNCE THE SYNC, EVEN WHEN NO BALANCE MOVED.
           The two lines above only fire when a NUMBER changed, but the thing
           that arrives on a first sync is the META: packs_opened, whether
           crystals are unlocked, whether today's free one is still there.
           A returning player whose hearts happen to be unchanged got no event
           at all, so a Shop rendered before this reply landed kept saying
           "Locked · 10 more packs" to somebody who had opened 25, and a card
           kept saying "Crystal needed" to somebody holding five. Nothing ever
           repainted them, because from the old code's point of view nothing
           had happened. */
        try { document.dispatchEvent(new CustomEvent('hoh:wallet-synced', {})); } catch (_) {}
        return true;
        }
      }, function () { return false; });
    },function(){return false;});
  }

  /* ---------- carrying the old browser balance across, once ---------- */
  /* ⛔ THIS RUNS AT MOST ONCE PER DEVICE PER ACCOUNT and is safe to call more.
     The server keeps a high-water mark and only ever credits the difference,
     so a second call adds nothing and an old device cannot hand back hearts
     that have already been spent. The local flag is only there to save a
     round trip. */
  function adoptKey(forEmail) { return 'hoh-wallet-adopted-' + String(forEmail||email()); }
  function adopt(authorityHeld, expectedScope) {
    if (!signedIn()) return Promise.resolve(false);
    var s=expectedScope||scope();
    if(!authorityHeld){
      return withWalletAuthority(s,false,function(){return adopt(true,s);}).then(function(r){return r;},function(){return false;});
    }
    if(!stillCurrent(s))return Promise.resolve(false);
    var ownerAtEntry=walletOwner();
    /* An ownerless LIVE cache is deliberately established from this
       account's authoritative wallet by ensureWalletOwner(). That freshly
       fetched balance is server truth, not a legacy local claim. Remember the
       entry state so we cannot immediately feed the fetched number back into
       hoh_wallet_adopt and credit it a second time. */
    var ownerlessLiveAtEntry=!ownerAtEntry&&!!readMeta().wallet_live;
    return ensureWalletOwner(s).then(function(ownerReady){
      if(!ownerReady||!ownsWallet(s))return false;
      /* On A→B, ensureWalletOwner has already fetched B without reconciling.
         Never feed the former A mirror into B's legacy high-water adoption. */
      if(ownerlessLiveAtEntry||(ownerAtEntry&&ownerAtEntry!==s.email))return true;
      /* An optimistic exact-id journal is not a legacy balance claim. Replay
         it before adoption or a lost earn could be credited once by the
         high-water claim and again by its original ledger request. */
      if(heartApplyPendings(s.email).length){
        return settleHeartApplyPendings(s,true,true).then(function(settled){
          if(!settled||!ownsWallet(s))return false;
          return sync(true,true,true);
        });
      }
      var localHearts=hearts();
      try{if(localStorage.getItem(adoptKey(s.email))==='1'&&readMeta().wallet_live)return false;}catch(_){}
      return rpc('hoh_wallet_adopt',{
        p_email:s.email,p_pin:s.pin,p_claim:localHearts,
        p_device:(navigator.userAgent||'').slice(0,120)
      }).then(function(res){
        if(!ownsWallet(s))return false;
        var d=res&&res.data;if(!d||d.ok!==true)return false;
        try{localStorage.setItem(adoptKey(s.email),'1');}catch(_){}
        return sync(true,false,true).then(function(){return true;});
      },function(){return false;});
    },function(){return false;});
  }

  /* ---------- the one write door ---------- */
  /* apply('hearts', -150, 'spend_shop_pack') and so on. Optimistic: the mirror
     moves now, the server confirms behind it, and a refusal puts it back.
     Resolves with { ok, applied, balance, status }. Never rejects, because a
     wallet that throws in a render path takes the screen with it. */
  function apply(currency, delta, reason, opts) {
    opts = opts || {};
    delta = delta | 0;
    var key = currency === 'crystals' ? CRYSTAL_KEY : HEART_KEY;
    if(signedIn()){
      var openingScope=scope(),openingOwner=walletOwner();
      if(opts.__walletAuthorityHeld&&
         (!opts.__walletScope||opts.__walletScope.email!==openingScope.email||opts.__walletScope.pin!==openingScope.pin))
        return Promise.resolve({ok:false,status:'account_changed',balance:readInt(key)});
      /* The cache still belongs to A. Do not put B's optimistic echo on top of
         it even for one paint. Establish B from B's authority first, then
         re-enter with the same logical request while the B lock stays held. */
      var ownerlessLive=!openingOwner&&!!readMeta().wallet_live;
      if(((openingOwner&&openingOwner!==openingScope.email)||ownerlessLive)&&!opts.__walletAuthorityHeld){
        var boundaryId=opts.requestId||reqId(reason);
        return withWalletAuthority(openingScope,false,function(){
          return ensureWalletOwner(openingScope).then(function(ready){
            if(!ready||!ownsWallet(openingScope))
              return {ok:false,status:'wallet_unverified',balance:readInt(key)};
            return apply(currency,delta,reason,{requestId:boundaryId,
              __walletAuthorityHeld:true,__walletScope:openingScope});
          });
        }).then(function(result){
          return result===false?{ok:false,status:'account_changed',balance:readInt(key)}:result;
        },function(){return {ok:false,status:'wallet_unverified',balance:readInt(key)};});
      }
      if(!openingOwner&&!ownerlessLive)setWalletOwner(openingScope.email);
    }
    var before = readInt(key);

    /* ⛔ AFFORDABILITY IS CHECKED BEFORE ANYTHING ELSE, SIGNED IN OR NOT.
       This guard used to sit below the signed-out branch, so a logged-out
       player spending 9 crystals while holding 3 was clamped to zero and told
       it worked. Caught by executing the funnel rather than reading it. The
       server enforces the same rule for a signed-in player; this is the only
       thing enforcing it for everyone else. */
    if (delta < 0 && before < -delta) {
      return Promise.resolve({
        ok: false,
        status: currency === 'crystals' ? 'insufficient_crystals' : 'insufficient_hearts',
        balance: before
      });
    }

    /* Signed out, or the sandbox with no account: stay purely local. God mode
       and a logged-out browse must keep working exactly as they do today. */
    if (!signedIn()) {
      var localNext = Math.max(0, Math.min(currency === 'crystals' ? 1e9 : HEART_MAX, before + delta));
      writeInt(key, localNext);
      if (currency === 'crystals') announceCrystals(); else announce(localNext - before, reason);
      return Promise.resolve({ ok: true, local: true, applied: localNext - before, balance: localNext });
    }

    var s = scope();
    if(walletOwner()!==s.email)
      return Promise.resolve({ok:false,status:'wallet_unverified',balance:before});
    var id = opts.requestId || reqId(reason);
    var optimistic = Math.max(0, Math.min(currency === 'crystals' ? 1e9 : HEART_MAX, before + delta));
    var hadShadow=false;
    try{hadShadow=localStorage.getItem(SHADOW_KEY)!==null;}catch(_){}
    writeInt(key, optimistic);
    var heartRow=currency==='hearts'?{
      email:s.email,id:id,delta:delta,localDelta:optimistic-before,reason:reason,
      echoPresent:true,coldBase:hadShadow?null:before
    }:null;
    if(heartRow)saveHeartApplyPending(heartRow);
    if (currency === 'crystals') announceCrystals();
    function callApplyRpc(){return rpc('hoh_wallet_apply', {
      p_email: s.email, p_pin: s.pin, p_currency: currency,
      p_delta: delta, p_reason: reason, p_request_id: id,
      p_device: (navigator.userAgent || '').slice(0, 120)
    }).then(function (res) {
      if (!ownsWallet(s)) return { ok: false, status: 'account_changed' };
      var d = res && res.data;
      /* ⛔ A DEAD SERVER MUST NOT SILENTLY KEEP THE OPTIMISTIC NUMBER FOREVER,
         but it must not roll back a SPEND either: the request may well have
         landed and only the reply was lost. Leave the mirror, mark it stale,
         and let the next sync replay this exact journal id before it reads or
         reconciles server truth. */
      if (!d) { markStale(); return { ok: false, status: 'offline', balance: readInt(key) }; }

      if (d.ok !== true) {
        /* ⛔ A REFUSAL THAT IS OUR OWN BUG MUST NOT COST THE PLAYER.
           `unknown_reason` and `reason_direction` mean the reason string is
           missing from ff_wallet_reason or is filed the wrong way round. That
           is a mistake in our table, not the player doing anything wrong, and
           rolling their hearts back to punish them for it is the wrong answer.
           Keep the optimistic value, shout in the console so it gets fixed,
           and let the next sync settle it against the server. */
        if (d.status === 'unknown_reason' || d.status === 'reason_direction') {
          try { console.error('R594 WALLET REASON REJECTED · reason=' + reason +
            ' currency=' + currency + ' delta=' + delta + ' status=' + d.status +
            ' · add it to ff_wallet_reason'); } catch (_) {}
          markStale();
          return { ok: false, status: d.status, balance: readInt(key), kept: true };
        }
        /* A later optimistic Heart move may already sit on top of this one.
           Remove only this operation's local echo; restoring `before`
           wholesale would erase its sibling. Crystal calls retain the legacy
           single-operation rollback. */
        var refusedNow=readInt(key),rollback;
        if(currency==='hearts'){
          removeHeartApplyEcho(heartRow);
          rollback=readInt(key);
        }else{
          rollback=before;writeInt(key,rollback);
        }
        if (currency === 'crystals') announceCrystals(); else announce(rollback-refusedNow, reason);
        return { ok: false, status: d.status || 'refused', balance: rollback };
      }
      /* the server is the number. It may have granted LESS than asked (a daily
         cap, or the 9999 ceiling), and the screen must show what landed rather
         than what was hoped for. */
      var settled = d.balance | 0;
      /* ⛔ R601: a move the funnel made and the server confirmed is NOT an
         un-synced raw write, so the shadow moves with it. Without this every
         ordinary spend would look like unexplained local drift on the next
         sync and be pushed back up. */
      var current=readInt(key),nextSettled=settled;
      if (currency === 'hearts') {
        /* Split the mirror explicitly: last server shadow + genuine raw R601
           drift + every journaled optimistic echo. The current operation now
           lives in `settled`; carry only the raw part and the OTHER pending
           rows forward. `settled + (current-optimistic)` lost raw drift that
           existed before this call (notably a kept policy refusal). */
        var allPending=heartApplyLocalDelta(s.email);
        var responseHadShadow=false;
        try{responseHadShadow=localStorage.getItem(SHADOW_KEY)!==null;}catch(_){}
        /* With no server shadow, the old mirror is not evidence of raw drift;
           adopt()/the authoritative reply decides that legacy baseline. */
        var raw=responseHadShadow?current-readInt(SHADOW_KEY)-allPending:0;
        var remainingPending=allPending-(optimistic-before);
        nextSettled=Math.max(0,Math.min(HEART_MAX,settled+raw+remainingPending));
        writeInt(SHADOW_KEY, settled);
      }
      if (nextSettled !== current) {
        writeInt(key, nextSettled);
        if (currency === 'crystals') announceCrystals(); else announce(nextSettled - current, reason);
      }
      return { ok: true, applied: d.applied | 0, requested: delta, capped: !!d.capped, balance: settled, status: d.status };
    }, function () {
      markStale();
      return { ok: false, status: 'offline', balance: readInt(key) };
    });}
    var work,flightKey=s.email+'\n'+id;
    if(heartRow){
      /* The mirror still moves above on the caller's stack, but server Heart
         mutations run in account order. If an earlier reply is ambiguous,
         later exact ids remain journaled and unsent until recovery resolves
         the first row; they can never overtake it and confuse the shadow. */
      work=withWalletAuthority(s,!!opts.__walletAuthorityHeld,function(){
        if(!stillCurrent(s))return {ok:false,status:'account_changed',balance:readInt(key)};
        return ensureWalletOwner(s).then(function(ownerReady){
          if(!ownerReady||!ownsWallet(s))
            return {ok:false,status:'wallet_unverified',balance:readInt(key)};
          var liveRows=heartApplyPendings(s.email);
          if(!liveRows.length||liveRows[0].id!==id)
            return {ok:false,status:'wallet_unverified',balance:readInt(key)};
          return ensureColdHeartBaseline(s,liveRows[0]).then(function(coldReady){
            if(!coldReady||!ownsWallet(s))
              return {ok:false,status:'wallet_unverified',balance:readInt(key)};
            var finalRows=heartApplyPendings(s.email);
            if(!finalRows.length||finalRows[0].id!==id)
              return {ok:false,status:'wallet_unverified',balance:readInt(key)};
            return callApplyRpc();
          });
        });
      });
    }else work=callApplyRpc();
    if(!heartRow)return work;
    var tracked=work.then(function(result){
      if(heartApplyFlights[flightKey]===tracked)delete heartApplyFlights[flightKey];
      /* Only a lost/unknown outcome keeps the exact-id blocker. A confirmed
         success, policy refusal, or affordability refusal has already moved
         the shadow or rolled the mirror back above. */
      var ambiguous=result&&(result.status==='offline'||result.status==='account_changed'||result.status==='wallet_unverified');
      if(!ambiguous)clearHeartApplyPending(heartRow);
      return result;
    },function(){
      if(heartApplyFlights[flightKey]===tracked)delete heartApplyFlights[flightKey];
      return {ok:false,status:'offline',balance:readInt(key)};
    });
    heartApplyFlights[flightKey]=tracked;
    /* Publish the optimistic Heart move only after its exact request is both
       journaled and tracked. A synchronous event listener may call sync(); it
       must see the flight and wait, never race an untracked mirror delta. */
    announce(optimistic-before,reason);
    return tracked;
  }

  /* ---------- crystals ---------- */
  /* An uncertain request stays in memory with its exact id and quantity. A
     second press checks that SAME logical purchase; it cannot accidentally
     create a new charge. New purchases reconcile R601 Heart drift first. */
  var crystalBuyAttempts = {};
  function buyCrystals(qty, opts) {
    opts = opts || {};
    if (!signedIn()) return Promise.resolve({ ok: false, status: 'signed_out' });
    var requested = Number(qty);
    /* Do not turn NaN, a fraction, zero, or a bitwise overflow into a one-
       crystal purchase. The server has the same validation; this guard keeps
       a malformed UI action from even looking like a legitimate request. */
    if (!isFinite(requested) || Math.floor(requested) !== requested ||
        requested < 1 || requested > 2147483647) {
      return Promise.resolve({ ok: false, status: 'invalid_quantity' });
    }
    /* One account authority covers Heart applies, drift reconciliation, and
       the full purchase preflight-to-RPC handoff. Capture the account before
       waiting: a queued A click can never turn into a B purchase. */
    if(!opts.__walletAuthorityHeld){
      var lockScope=scope();
      return withWalletAuthority(lockScope,false,function(){
        if(!stillCurrent(lockScope))return {ok:false,status:'account_changed'};
        return buyCrystals(qty,{requestId:opts.requestId,__walletAuthorityHeld:true,
          __walletScope:lockScope});
      }).then(function(r){
        return r===false?{ok:false,status:'account_changed'}:r;
      },function(){return {ok:false,status:'wallet_unverified'};});
    }
    if(!opts.__walletScope||opts.__walletScope.email!==email()||opts.__walletScope.pin!==pin())
      return Promise.resolve({ok:false,status:'account_changed'});
    var s = scope(), saved = crystalBuyPending(s.email);
    /* A possibly committed purchase must be checked before a different one
       starts. The durable account-scoped journal survives closing the sheet
       and even a page reload; it contains no PIN or other credential. */
    if(saved && !opts.requestId)
      return Promise.resolve({ok:false,status:'pending_purchase',pending:saved});
    if(saved && (String(opts.requestId||'')!==saved.id || requested!==saved.qty))
      return Promise.resolve({ok:false,status:'pending_purchase',pending:saved});
    var id = opts.requestId || reqId('buy');
    var attempt = crystalBuyAttempts[id];
    if (attempt && (attempt.email !== s.email || attempt.qty !== requested)) {
      return Promise.resolve({ ok: false, status: 'request_conflict' });
    }
    if (attempt && attempt.promise) return attempt.promise;
    if (!attempt) attempt = crystalBuyAttempts[id] = {
      email:s.email,qty:requested,cost:saved?saved.cost:0,
      sent:!!saved,promise:null
    };

    function send() {
      attempt.sent = true;
      saveCrystalBuyPending({email:s.email,id:id,qty:requested,cost:attempt.cost});
      return rpc('hoh_crystal_buy', {
        p_email: s.email, p_pin: s.pin, p_qty: requested, p_request_id: id
      }).then(function (res) {
        if (!ownsWallet(s)) return { ok: false, status: 'account_changed' };
        var d = res && res.data;
        if (!d) return { ok: false, status: 'offline' };
        if (d.ok !== true) {
          /* R605 returns the balances that defeated a stale quantity. Adopt
             them immediately so the still-open sheet can lower its maximum
             and cannot present the refusal as a successful purchase. */
          if (d.hearts != null && d.crystals != null) applyPurchaseReceipt(d, s.email);
          return { ok: false, status: d.status, cost: Number(d.cost) || 0,
            affordable: Number(d.affordable) || 0,
            unlockPacks: d.unlock_packs | 0, packsOpened: d.packs_opened | 0 };
        }
        /* SQL-first rollout is enforced here, not assumed. An R589 tab/server
           can answer requested 38 with a capped qty 12. Missing model, a
           rewritten quantity, incoherent cost, or malformed balances is not
           a purchase receipt and must leave the exact request journal intact. */
        if (!validPurchaseSuccess(d,requested,attempt.cost) ||
            !applyPurchaseReceipt(d, s.email)) return { ok: false, status: 'invalid_reply' };
        /* Refresh the ancillary metadata after the exact receipt has landed.
           The revision fence prevents an older coalesced read from winning. */
        return sync(true,false,true).then(function () {
          if (!ownsWallet(s)) return { ok: false, status: 'account_changed' };
          return { ok: true, qty: Number(d.qty), cost: Number(d.cost),
            crystals: Number(d.crystals), hearts: Number(d.hearts),
            replayed: d.status === 'already' };
        });
      }, function () { return { ok: false, status: 'offline' }; });
    }

    /* A NEW request must first carry mirror-minus-shadow to the server. An
       uncertain retry deliberately skips this preparation and goes straight
       to the same idempotent endpoint: it may already have committed. */
    var work = ensureWalletOwner(s).then(function(ownerReady){
      if(!ownerReady||!ownsWallet(s))return {ok:false,status:'wallet_unverified'};
      if(attempt.sent)return send();
      return sync(true,false,true).then(function (ready) {
        if (!ownsWallet(s)) return { ok: false, status: 'account_changed' };
        if (!ready) return { ok: false, status: 'wallet_unverified' };
        var price = crystalPrice(), affordable = crystalBuyMax();
        if (!isFinite(price) || Math.floor(price) !== price || price <= 0)
          return { ok: false, status: 'price_unavailable' };
        if (requested > affordable)
          return { ok: false, status: 'insufficient_hearts', cost: requested * price,
            affordable: affordable };
        attempt.cost=requested*price;
        return send();
      });
    },function(){return {ok:false,status:'wallet_unverified'};});
    attempt.promise = work.then(function (result) {
      attempt.promise = null;
      /* Offline/account-changed after SEND is ambiguous, so retain the exact
         request for a replay. Every definitive answer, and any failure before
         send, releases it. */
      var ambiguous=result&&(result.status==='offline'||result.status==='account_changed'||result.status==='invalid_reply');
      if (!attempt.sent || !result || !ambiguous){
        clearCrystalBuyPending({email:s.email,id:id});
        delete crystalBuyAttempts[id];
      }
      return result;
    }, function () {
      attempt.promise = null;
      if (!attempt.sent) delete crystalBuyAttempts[id];
      return { ok: false, status: 'offline' };
    });
    return attempt.promise;
  }

  function claimDailyCrystal() {
    if (!signedIn()) return Promise.resolve({ ok: false, status: 'signed_out' });
    var s = scope();
    return rpc('hoh_crystal_claim_daily', { p_email: s.email, p_pin: s.pin }).then(function (res) {
      if (!stillCurrent(s)) return { ok: false, status: 'account_changed' };
      var d = res && res.data;
      if (!d) return { ok: false, status: 'offline' };
      if (d.ok !== true) return { ok: false, status: d.status, unlockPacks: d.unlock_packs | 0, packsOpened: d.packs_opened | 0 };
      return sync(true).then(function () { return { ok: true, granted: !!d.granted, crystals: d.crystals | 0 }; });
    }, function () { return { ok: false, status: 'offline' }; });
  }

  /* one crystal, one reroll. Kept as its own verb so every caller spends the
     same reason and the ledger reads honestly. */
  function spendCrystalForRoll(opts) { return apply('crystals', -1, 'spend_crystal_roll', opts); }
  function refundCrystal(opts)       { return apply('crystals',  1, 'earn_crystal_refund', opts); }

  /* ---------- wake up ---------- */
  function boot() {
    if (!signedIn()) return;
    adopt().then(function () { return sync(true); });
  }
  try {
    document.addEventListener('hoh:signed-in', function () { lastSyncAt[email()]=0; boot(); });
    document.addEventListener('hoh:signed-out', function () { lastSyncAt={}; });
    /* another tab moved the money */
    window.addEventListener('storage', function (e) {
      if (!e) return;
      if (e.key === HEART_KEY || e.key === CRYSTAL_KEY) { try { announceCrystals(); } catch (_) {} }
      if (e.key === META_KEY) { try { announcePacks(); } catch (_) {} }
    });
  } catch (_) {}
  if (document.readyState === 'loading') {
    try { document.addEventListener('DOMContentLoaded', boot); } catch (_) {}
  } else { setTimeout(boot, 0); }

  /* ---------- the crystal, drawn once ----------
     ⛔ ONE DEFINITION, TWO SURFACES. The reroll button lives in
     hoh-contract-ui.js and the shop module lives in hoh-shop.js. Two copies of
     this path would drift the first time one is retuned, so both ask here.
     Spined at W3: the body is a four-facet shard, the bright core is a fixed
     FRACTION of it (0.45) so widening never turns the spine into a stripe.
     ⛔ THE GRADIENT IS DEFINED ONCE IN THE DOCUMENT AND REFERENCED BY ID.
     A gradient inside every icon means duplicate ids on the page, and the
     browser resolves url(#id) to the FIRST one, so every crystal would quietly
     inherit whichever rendered first. */
  var XTAL_HALF = 7.2, XTAL_CORE = 3.24;
  var defsPlanted = false;
  function plantDefs() {
    if (defsPlanted) return;
    defsPlanted = true;
    try {
      var d = document.createElement('div');
      d.setAttribute('aria-hidden', 'true');
      d.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
      d.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg"><defs>' +
        '<linearGradient id="hohXtalGrad" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#f7c4ff"/><stop offset="100%" stop-color="#9de6dd"/>' +
        '</linearGradient></defs></svg>';
      (document.body || document.documentElement).appendChild(d);
    } catch (_) {}
  }
  /* glow scales with the icon: a 16px mark must not wear a 96px halo */
  function icon(size, glow) {
    plantDefs();
    size = size || 16;
    var f = glow === false ? '' :
      'filter:drop-shadow(0 0 ' + (size * 0.055).toFixed(2) + 'px rgba(239,148,255,.85))' +
      ' drop-shadow(0 0 ' + (size * 0.14).toFixed(2) + 'px rgba(179,245,238,.4));';
    return '<svg class="hoh-xtal" viewBox="0 0 24 24" width="' + size + '" height="' + size +
      '" aria-hidden="true" focusable="false" style="' + f + 'display:block;flex:none">' +
      '<path fill="url(#hohXtalGrad)" fill-opacity=".6" d="M12 1.5 ' + (12 + XTAL_HALF) + ' 8.8 12 22.4 ' + (12 - XTAL_HALF) + ' 8.8Z"/>' +
      '<path fill="url(#hohXtalGrad)" d="M12 1.5 ' + (12 + XTAL_CORE) + ' 8.9 12 22.4 ' + (12 - XTAL_CORE) + ' 8.9Z"/>' +
      '<path stroke="#0a0a0f" stroke-opacity=".3" stroke-width=".7" fill="none" d="M' + (12 - XTAL_HALF) + ' 8.8h' + (XTAL_HALF * 2) + '"/>' +
      '</svg>';
  }

  window.HOHWallet = {
    icon: icon,
    hearts: hearts, crystals: crystals, meta: meta,
    unlocked: unlocked, packsOpened: packsOpened, packsUnopened: packsUnopened,
    accountPacksUnopened: accountPacksUnopened, battlePacksUnopened: battlePacksUnopened,
    unlockPacks: unlockPacks,
    crystalPrice: crystalPrice, crystalBuyMax: crystalBuyMax,
    pendingCrystalPurchase: crystalBuyPending, pendingCrystalPurchases: crystalBuyPendings,
    crystalsSpent: crystalsSpent, dailyCrystalReady: dailyCrystalReady,
    apply: apply, sync: sync, adopt: adopt, applyCrystalReceipt: applyCrystalReceipt,
    buyCrystals: buyCrystals, claimDailyCrystal: claimDailyCrystal,
    spendCrystalForRoll: spendCrystalForRoll, refundCrystal: refundCrystal,
    signedIn: signedIn, accountEmail: email, HEART_MAX: HEART_MAX
  };
})();

/* =====================================================================
   hohHeartBurst · HEARTS POP WHERE THEY ARE FOUND
   Jan, 2026-09-27: "it should not fly to the top left corner as its doing
   now, just do some heart particle effects and feel clean and fun instead
   of having it fly places, we are removing the heart economy so theres no
   point of it flying to your wallet".

   ⛔ PURELY A VISUAL. It reads no balance and writes none; the funnel above
   is untouched. It lives in this file only because this file loads first of
   every Hall module that finds or gives hearts (the script order in
   sections/hall-of-heroes.liquid). Its look is `.hoh-hb` in
   hall-of-heroes.css.

   window.hohHeartBurst(src, opts) -> true when it drew something
     src   an Element (its centre; a detached or hidden one falls back to
           el.__hohRectSnap, else nothing is drawn), a rect
           {left, top, width, height}, or a point {x, y}, in viewport px
     opts.n     how many hearts it stands for: 6 particles for 1, growing
                gently to 10
     opts.tone  'pink' (default), 'blue' (also 'xp') or 'purple'
     opts.label optional short text ('+3') that rises 20px and fades

   ⛔ NOTHING TRAVELS. Particles spread 30 to 60px from the source (up to
     78px round a big one) and are gone by about 0.9s. The old flights aimed
     at the wallet pill, and the live Hall hides that pill (display:none
     measures 0,0), so they flew to the top-left corner.
   ⛔ A source 90px or more across (the die, a card) keeps its centre clear:
     no centre heart over the rolled number or the face, a wider ring round
     it, and under reduced motion the one heart sits at its top edge.
   ⛔ Transform and opacity only, position:fixed, pointer-events:none, above
     every Hall sheet (z 1000000), and inside an open <dialog> when the
     source is in one (the top layer beats any z-index). The layer removes
     itself when its last animation ends, and a timer removes it anyway.
   ⛔ Reduced motion: one heart fades in and out in place. Nothing moves.
   ⛔ A stream (hold-to-give, XP feeding) repeats on one element faster than
     a burst can play: inside 160ms it draws a 3-heart mini pop, and no more
     than 8 bursts are ever alive at once.
   ===================================================================== */
(function () {
  var PATH = 'M12 21S3 15 3 8a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 7-9 13-9 13Z';
  var HEART = '<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="' + PATH + '"/></svg>';
  var TONES = {
    pink: ['#ff6f9f', '#ef94ff', '#ff9cc7', '#ffc4de', '#ff85b3'],
    blue: ['#7ed4ff', '#a4d8ff', '#b3f5ee', '#d5efff'],
    purple: ['#ef94ff', '#c9a0ff', '#ffb3f2', '#b794f4']
  };
  var MAX_LIVE = 8, REPEAT_MS = 160, live = 0;

  function reduced() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
    catch (_) { return false; }
  }
  /* the viewport point at the centre of whatever was passed, with its box */
  function centreOf(src) {
    var r = null;
    if (!src) return null;
    if (typeof src.getBoundingClientRect === 'function') {
      try { if (src.isConnected !== false) r = src.getBoundingClientRect(); } catch (_) { r = null; }
      if (!r || (!r.width && !r.height)) r = src.__hohRectSnap || null;
    } else if (typeof src.left === 'number' && typeof src.top === 'number') {
      r = src;
    } else if (typeof src.x === 'number' && typeof src.y === 'number') {
      return { x: src.x, y: src.y, top: src.y, w: 0, h: 0 };
    }
    if (!r || (!r.width && !r.height)) return null;
    return { x: r.left + (r.width || 0) / 2, y: r.top + (r.height || 0) / 2, top: r.top, w: r.width || 0, h: r.height || 0 };
  }
  function px(v) { return (Math.round(v * 10) / 10) + 'px'; }

  function heartBurst(src, opts) {
    try {
      opts = opts || {};
      if (live >= MAX_LIVE || !document.body) return false;
      var at = centreOf(src);
      if (!at) return false;
      var vw = window.innerWidth || document.documentElement.clientWidth || 0;
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (at.x < -40 || at.y < -40 || at.x > vw + 40 || at.y > vh + 40) return false;
      var el = (src && src.nodeType === 1) ? src : null;
      var mini = false, now = Date.now();
      if (el) {
        if (el.__hohHbAt && now - el.__hohHbAt < REPEAT_MS) mini = true;
        el.__hohHbAt = now;
      }
      var calm = reduced();
      var tone = opts.tone === 'xp' ? 'blue' : (TONES[opts.tone] ? opts.tone : 'pink');
      var cols = TONES[tone];
      var n = Math.max(1, +opts.n || 1);
      var k = calm ? 0 : (mini ? 3 : Math.max(6, Math.min(10, 5 + Math.round(Math.sqrt(n)))));
      /* A big source (a die, a card, a banner) carries its own content at its
         centre, the rolled number or a face: no centre heart over it, a wider
         ring around it, and a spread that grows a little with it. */
      var side = Math.min(at.w, at.h), big = side >= 90;
      var reach = Math.max(30, Math.min(48, side * 0.3));
      if (calm && big) at.y = at.top + Math.min(18, at.h / 2);
      var html = '';
      for (var i = 0; i < k; i++) {
        /* fanned mostly upward (-190deg to +10deg), each with a little jitter */
        var ang = (-90 + ((k > 1 ? i / (k - 1) : 0.5) - 0.5) * 200 + (Math.random() * 24 - 12)) * Math.PI / 180;
        var dist = mini ? 16 + Math.random() * 14 : reach + Math.random() * 30;
        var dur = Math.round((mini ? 520 : 640) + Math.random() * 180);
        var size = mini ? 10 + Math.round(Math.random() * 3) : 12 + Math.round(Math.random() * 6);
        html += '<i class="hoh-hb-p" style="--dx:' + px(Math.cos(ang) * dist) + ';--dy:' + px(Math.sin(ang) * dist) +
          ';--fall:' + px(10 + Math.random() * 14) + ';--r:' + Math.round(Math.random() * 60 - 30) + 'deg;--s:' +
          (0.75 + Math.random() * 0.45).toFixed(2) + ';--z:' + size + 'px;color:' + cols[i % cols.length] +
          ';animation-duration:' + dur + 'ms;animation-delay:' + Math.round(Math.random() * 60) + 'ms">' + HEART + '</i>';
      }
      if (!mini) html = (calm ? '' : '<i class="hoh-hb-ring"></i>') + (calm || !big ? '<i class="hoh-hb-core">' + HEART + '</i>' : '') + html;
      var layer = document.createElement('span');
      layer.className = 'hoh-hb hoh-hb-' + tone + (calm ? ' hoh-hb-calm' : '') + (mini ? ' hoh-hb-mini' : '') + (big ? ' hoh-hb-big' : '');
      layer.setAttribute('aria-hidden', 'true');
      layer.style.cssText = 'position:fixed;display:block;left:' + px(at.x) + ';top:' + px(at.y) +
        ';width:0;height:0;pointer-events:none;z-index:1000000;';
      layer.innerHTML = html;
      if (opts.label && !calm && !mini) {
        var tag = document.createElement('b');
        tag.className = 'hoh-hb-label';
        tag.textContent = String(opts.label).slice(0, 8);
        layer.appendChild(tag);
      }
      var host = (el && el.closest && el.closest('dialog[open]')) || document.body;
      host.appendChild(layer);
      /* a <dialog> with a transform is the containing block of its fixed
         children: measure where the point really landed and correct once */
      if (host !== document.body) {
        var got = layer.getBoundingClientRect();
        if (Math.abs(got.left - at.x) > 1 || Math.abs(got.top - at.y) > 1) {
          layer.style.left = px(at.x * 2 - got.left);
          layer.style.top = px(at.y * 2 - got.top);
        }
      }
      live++;
      var gone = false, seen = 0, expect = layer.children.length;
      function end() {
        if (gone) return;
        gone = true;
        live = Math.max(0, live - 1);
        try { if (layer.parentNode) layer.parentNode.removeChild(layer); } catch (_) {}
      }
      layer.addEventListener('animationend', function () { if (++seen >= expect) end(); });
      setTimeout(end, (calm || mini) ? 900 : 1150);
      return true;
    } catch (_) { return false; }
  }
  window.hohHeartBurst = heartBurst;
})();
